export default __webpack_public_path__ + "static/media/speaker24.cb444cfc.png";